import { useTranslation } from 'react-i18next';
import { Link } from 'react-router-dom';
import { Icon } from '../../components/Icon';
import { ThemeToggleButton } from '../../components/ThemeToggleButton';
import { MonographViewSwitch } from './MonographViewSwitch';

/**
 * #929 (epic #934): the Monograph's slim header -- where you are (PeruseLab › Monographs › name),
 * the Cards | Sheet switch and the theme button (#928). Shared by both views.
 */
export function MonographHeaderBar({
  name,
  onPrint,
  printBusy = false
}: {
  readonly name: string | null;
  readonly onPrint?: () => void;
  readonly printBusy?: boolean;
}) {
  const { t } = useTranslation();
  return (
    <div className="monograph-header-bar">
      <nav aria-label={t('monograph.breadcrumb')} className="monograph-breadcrumb">
        <ol>
          <li className="monograph-breadcrumb-parent">
            <Link to="/">{t('monograph.home')}</Link>
          </li>
          <li className="monograph-breadcrumb-parent">{t('monograph.monographs')}</li>
          {name ? (
            <li aria-current="page" dir="auto" title={name}>
              {name}
            </li>
          ) : null}
        </ol>
      </nav>
      <div className="monograph-header-controls">
        {onPrint ? (
          <button
            type="button"
            className="icon-button"
            disabled={printBusy}
            onClick={onPrint}
            aria-label={t('printing.profile')}
            title={t('printing.profile')}
          >
            <Icon name="print" />
          </button>
        ) : null}
        <MonographViewSwitch />
        <ThemeToggleButton />
      </div>
    </div>
  );
}
